const Flickity = require('flickity');
require('flickity-fade');

export default () => {

    const slider = document.querySelector('[data-hero-slider]');
    if (slider) {
        if (slider.children.length > 1) {
            const flickity = new Flickity(slider, {
                fade: true,
                cellAlign: 'left',
                contain: true,
                prevNextButtons: true,
                pageDots: false,
                autoPlay: 5000,
                wrapAround: true,
                selectedAttraction: 0.006,
                friction: 0.2,
                arrowShape: 'M40.1051 0L50.2107 10.1838L27.474 32.8612H100V47.1388H27.474L50.2107 69.8162L40.1051 80L2.86964e-06 39.9996L40.1051 0Z'
            });
        }
    }

    const carousels = document.querySelectorAll('[data-hero-carousel]');

    if(carousels) {
        for (const carousel of carousels) {
            if (carousel.children.length) {
                const flkty = new Flickity(carousel, {
                    cellAlign: 'left',
                    imagesLoaded: true,
                    wrapAround: true,
                    freeScroll: true,
                    freeScrollFriction: 0.03,
                    pageDots: false,
                    prevNextButtons: true,
                    autoPlay: 2000,
                    arrowShape: 'M40.1051 0L50.2107 10.1838L27.474 32.8612H100V47.1388H27.474L50.2107 69.8162L40.1051 80L2.86964e-06 39.9996L40.1051 0Z'
                });
            }
        }

    }
}
